module.exports = __webpack_public_path__ + "img/图片5.173a1873.jpg";